import 'firebase/auth';

import axios from '@/axios';

export default {
  fetchCommunityMembers() {
    return new Promise((resolve, reject) => {
      axios
        .get(
          '/api/v1/admins/fetchCommunityMembers'
        )
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

};
